import { render, staticRenderFns } from "./SpecialistRegister.vue?vue&type=template&id=5ca8a33f&scoped=true&lang=pug&"
import script from "./SpecialistRegister.vue?vue&type=script&lang=js&"
export * from "./SpecialistRegister.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistRegister.vue?vue&type=style&index=0&id=5ca8a33f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca8a33f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VApp,VFlex,VForm,VLayout,VTab,VTabItem,VTabs,VTabsItems})
